export default {
    charlyHomeColor: 'pdc-charly-home-background',
    charlyMtgColColor: 'pdc-charly-mtgcol-background',
    charlyNotisColor: 'pdc-charly-notis-background',
    charlyFavsColor: 'pdc-charly-favs-background',
    charlyToolsColor: 'pdc-charly-tools-background',
    charlyFontColor: 'pdc-charly-font-color',
    primaryColor: 'pdc-customization-primary-color',
    primaryBackgroundColor: 'pdc-customization-primary-backgroundcolor',
    secondaryColor: 'pdc-customization-secondary-color',
    secondaryBackgroundColor: 'pdc-customization-secondary-backgroundcolor',
};